import React, { useCallback, useContext, useEffect, useState } from "react";
import { Blog } from "../../../client/api";
import { ClavaContext } from "../../../config/contexts";
import { showTranslated } from "../../../config/translator";
import ScaleFade from "../Animated/ScaleFade";
import ClavaImage from "../ClavaImage";
import RoundedRectangle from "../RoundedRectangle";

type NewsItemProps = {
  news: Blog;
  onClick: () => void;
  variant?: "desktop" | "tablet" | "mobile" | "grid";
};

const NewsItem: React.FC<NewsItemProps> = ({ news, onClick, variant = "mobile" }) => {
  const { l } = useContext(ClavaContext);
  const [imageKey, setImageKey] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setImageKey((prev) => prev + 1);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClick = useCallback(() => {
    onClick();
  }, [onClick]);

  const title = showTranslated(news.title, l);
  const isTablet = variant === "tablet";
  const isGrid = variant === "grid";

  const content = (
    <RoundedRectangle
      className={`w-full overflow-hidden bg-bg-secondary dark:bg-bg-secondary-dark ${
        isTablet ? "h-full" : ""
      }`}
      hasBorder={false}
      hasTitle={false}
    >
      <button
        type="button"
        onClick={handleClick}
        className={`w-full text-left ${isTablet ? "h-full flex flex-col" : ""}`}
      >
        <div
          className={`w-full overflow-hidden rounded-t-xl ${
            isTablet ? "flex-shrink-0" : ""
          }`}
        >
          <ClavaImage
            key={`${news.id}-${imageKey}`}
            image={news.image}
            width="100%"
            format="full"
            className="rounded-t-xl"
            alt={title}
          />
        </div>
        <div
          className={`px-4 pt-3 pb-4 ${
            isTablet ? "flex-1 flex flex-col justify-center" : ""
          }`}
        >
          <h3
            className={`text-sm font-semibold text-font dark:text-font-dark ${
              isTablet ? "line-clamp-3" : "line-clamp-2"
            }`}
          >
            {title}
          </h3>
        </div>
      </button>
    </RoundedRectangle>
  );

  if (isGrid) {
    return (
      <div className="w-full min-w-0 hover-capable">
        {content}
      </div>
    );
  }

  return (
    <ScaleFade isOpen hover className="block relative">
      {content}
    </ScaleFade>
  );
};

export default NewsItem;

